import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { Banka } from './banka';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-banka-update',
  templateUrl: './banka-update.component.html'
})
export class BankaUpdateComponent extends BaseUpdateComponent<Banka> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }
  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Sifra", Validators.required, 'required', 'BANKA.SIFRA.VALIDATION.REQUIRED');
    this.addValidatorToFc("Sifra", Validators.maxLength(4), 'maxlength', 'BANKA.SIFRA.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Naziv", Validators.required, 'required', 'BANKA.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.maxLength(100), 'maxlength', 'BANKA.NAZIV.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Adresa", Validators.required, 'required', 'BANKA.ADRESA.VALIDATION.REQUIRED');
    this.addValidatorToFc("Adresa", Validators.maxLength(100), 'maxlength', 'BANKA.ADRESA.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("MestoID", Validators.required, 'required', 'BANKA.MESTOID.VALIDATION.REQUIRED');
  }

}
